import { supabase } from "../../utilities/service/SupabaseConnector"

class ReservationService{
    public async submitReservation(reservationData:any){
        const response = await supabase.from('reservations').insert(([
            {
              name: reservationData.name,
              phone_number: reservationData.phone_number,
              time_date: reservationData.time_date,
              people_amount: reservationData.people_amount,
              note: reservationData.note,
            }]));
        return response;
    }
}
export const reservationService = new ReservationService()